export enum InteractableState {
    Closed = 'closed',
    Open = 'open',
    Locked = 'locked',
    Broken = 'broken',
    Used = 'used',
    Hidden = 'hidden',
    Active = 'active'
}
